import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import "../../../i18n";
import './style.css';

import EmailIcon from '@mui/icons-material/Email';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Alert, Dialog, DialogContent, InputAdornment } from "@mui/material";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logEvent } from "../../../analytics";
import HeartIcon from '../../../assets/icons/SVGIcons/Heart 16-16 1.svg';
import GMZbgLight from '../../../assets/images/SigninPageImages/BG_for_Login_12-10-2024-Light.webp';
import GMZbgDark from '../../../assets/images/SigninPageImages/BG_for_Login_12-10-2024-Dark.webp';
import GamizignLogo from '../../../assets/images/SigninPageImages/Gamizign-logo.png';
import LanguageSwitcher from "../../GlobalComponents/LanguagePicker";
import MetaTags from "../../GlobalComponents/MetaData";
import ThemeToggle from "../../GlobalComponents/ThemeToggle";



const SignIn = ({ mode, setMode }) => {
  const location = useLocation();
  const { animationStop } = location.state || "";
  const logoRef = useRef(null);
  const [showLoginFields, setShowLoginFields] = useState(animationStop ? true : false);
  const { t, i18n } = useTranslation();

  const [cohort, setCohort] = useState(() => {
    const isExpired = localStorage.getItem("gamizign_license_expired") === "true";
    const isReturning = localStorage.getItem("gamizign_returning_instructor") === "true";
    if (isExpired) return "returning_expired";
    if (isReturning) return "returning_active";
    return "first_timer";
  });

  const [simulatedStep, setSimulatedStep] = useState('idle');
  const [simulatedMaterial, setSimulatedMaterial] = useState('');
  const [simulatedText, setSimulatedText] = useState('');

  const startSimulation = (type) => {
    setSimulatedMaterial(type);
    setSimulatedStep('processing');

    const steps = i18n.language === 'ar' ? [
      "🔍 جاري فحص هيكل الملف...",
      "🧠 جاري استخراج الأسئلة التعليمية...",
      "⚡ جاري تصميم مستويات اللعبة التفاعلية..."
    ] : [
      "🔍 Scanning document nodes...",
      "🧠 Extracting interactive questions...",
      "⚡ Designing beautiful quest stages..."
    ];

    setSimulatedText(steps[0]);

    setTimeout(() => {
      setSimulatedText(steps[1]);
      setTimeout(() => {
        setSimulatedText(steps[2]);
        setTimeout(() => {
          setSimulatedStep('done');
        }, 1200);
      }, 1000);
    }, 800);
  };

  const [IncEmail, setIncEmail] = useState('')
  const navigate = useNavigate();
  const [state, setState] = useState({
    showPassword: false,
    password: '',
    error: '',
    isLoading: false,
  });
  // Navigate payment page for repay
  const [detalsData, setdetalsData] = useState(null)
  const repay = () => {
    navigate(`/upgradeplan`, { state: detalsData });
  }
  // ReActivate Account handle
  const ReActivateAccount = async () => {
    setProgrees(true);
    try {
      const respons = await axios.post(`${process.env.REACT_APP_ENDPOINT}/instructors/${detalsData.user.instructor_id}/reactivate`);
      const authData = { target: { email: { value: detalsData.authData.username }, password: { value: detalsData.authData.password } } }
      await handleSubmit(authData);
      setErrorMessage(t('Signin.ReactiveSuccess'));
    } catch (error) {
      console.log(error);
      setErrorMessage(t('Signin.ErrorReactive'));
    } finally { setProgrees(false); }
  }
  // Login handle
  const currentDomain = window.location.hostname;
  const handleSubmit = async (event) => {
    logEvent('signin', 'login clicked', 'Login by enetering email and password');
    if (event.preventDefault) event.preventDefault();
    setState((prevState) => ({ ...prevState, error: '', isLoading: true }));
    handleLoginResult(true);
    const authData = {
      username: event.target.email.value,
      password: event.target.password.value
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_ENDPOINT}/token`, authData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        }
      });
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
      const responseData = response.data;
      localStorage.setItem("user_type", responseData.user_type);
      Cookies.set("token", `Bearer ${responseData.access_token}`, {
        expires: 30,
        secure: true,
        sameSite: "Lax",
        domain: currentDomain // <-- Note: Still recommend removing this for stability (see below)
      });
      if (responseData.user.is_deactivated) {
        setErrorMessage(t('Signin.AccountDeactivatedMsg'));
        setPymentError(true);
        setdetalsData({ ...responseData, authData });
        setState((prevState) => ({ ...prevState, error: t('Signin.AccountDeactivated'), isLoading: false }));
        return;
      }

      if (responseData.user_type === "Instructor") {
        const getCoursesCount = await axios.get(`${process.env.REACT_APP_ENDPOINT}/instructors/{instructor_id}/account/?email=${authData.username}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${responseData.access_token}`
          }
        });
        const { firstName, lastName, email, instructor_id, organization_id, emailActivated, accountActive, admin_id, single_count, journey_count, questions_count, student_count, profilePicture } = getCoursesCount.data;
        const LearnerTab = admin_id ? 'hide' : 'show';
        const Onboarding = accountActive ? 2 : 0;
        Cookies.set("instructor_id", instructor_id, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        localStorage.setItem("profilePicture", profilePicture);
        Cookies.set("admin_id", admin_id, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        localStorage.setItem("name", firstName);
        localStorage.setItem("lastname", lastName);
        localStorage.setItem("email", email);
        localStorage.setItem("gamizign_returning_instructor", "true");
        localStorage.setItem("gamizign_last_login_email", email);
        localStorage.removeItem("gamizign_license_expired");
        Cookies.set("organization", organization_id, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        localStorage.setItem("LearnersList", LearnerTab);
        localStorage.setItem("accountActive", single_count + journey_count);
        Cookies.set("plan", responseData.license.license_type, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        localStorage.setItem("coursesLength", single_count + journey_count);
        localStorage.setItem("singleCourses", single_count);
        localStorage.setItem("journeyCourses", journey_count);
        localStorage.setItem("qestionListsLength", questions_count);
        localStorage.setItem("studentsLength", student_count);
        localStorage.setItem("emailActive", emailActivated ? emailActivated : "");
        Cookies.set("activatedTrial", responseData.license.activatedTrial ? responseData.license.activatedTrial : "", {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        const urlPath = localStorage.getItem('urlPath');
        if (urlPath) {
          localStorage.removeItem('urlPath');
          window.location.href = urlPath;
        }
        else if ((single_count + journey_count) > 0) {
          window.location.href = `/Dashboard`;
          sessionStorage.setItem("tab", responseData.license.license_type > 2 ? 11 : 4);
        } else {
          window.location.href = `/Dashboard/CreateCourse`;
          sessionStorage.setItem("tab", 1);
        }
      } else {
        Cookies.set("admin_id", responseData.user.admin_id, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        localStorage.setItem("adminName", responseData.user.first_name);
        localStorage.setItem("adminEmail", responseData.user.email);
        Cookies.set("organization", responseData.user.organization_id, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        Cookies.set("plan", responseData.license.license_type, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        window.location.href = `/Admin`;
      }

      handleLoginResult(true);
      setState((prevState) => ({ ...prevState, error: '', isLoading: false }));
    } catch (error) {
      let errorMessage = '';
      if (error?.response?.status === 402) {
        const detail = error.response.data.detail;
        Cookies.set("token", `Bearer ${detail.access_token}`, {
          expires: 30,
          secure: true,
          sameSite: "Lax",
          domain: currentDomain // <-- Note: Still recommend removing this for stability (see below)
        });

        localStorage.setItem("email", authData.username);
        localStorage.setItem('updatesPlan', detail.license_type);
        localStorage.setItem('updatesBill_type', detail.bill_type);
        setdetalsData(detail);
        localStorage.setItem("gamizign_license_expired", "true");
        setCohort("returning_expired");
        if (detail.new_user) {
          setErrorMessage(t('Signin.LicenseExpired'));
          setPymentError(true);
          setTimeout(() => {
            navigate('/payment', {
              state: {
                license_type: detail.license_type,
                bill_type: detail.bill_type,
                organization_id: detail.organization_id
              }
            });
          }, 2000);
          // navigate('/payment', { state: { license_type: detail.license_type, bill_type: detail.bill_type, organization_id: detail.organization_id } });
        } else {
          setErrorMessage(t('Signin.LicenseExpired1'));
          setPymentError(true);
        }

      } else {
        errorMessage = t('Signin.InvalidLogin');
      }
      setState((prevState) => ({ ...prevState, error: errorMessage, isLoading: false }));
      handleLoginResult(false);
      console.error('Error during login:', error);
    }
  };

  const togglePasswordVisibility = () => {
    setState((prevState) => ({ ...prevState, showPassword: !prevState.showPassword }));
  };

  const handleLoginResult = (isCorrectLogin) => {
    const inputs = document.querySelectorAll("input");

    inputs.forEach((input) => {
      input.readOnly = isCorrectLogin;
    });
  }
  // login  wih google
  const handleGoogleLogin = async (credentialResponse) => {
    logEvent('signin', 'login clicked', 'Login by google');
    var jwtToken = credentialResponse.credential.toString();
    setState((prevState) => ({ ...prevState, error: '', isLoading: true }));
    let errorMgs;
    try {
      const response = await fetch(`${process.env.REACT_APP_ENDPOINT}/handle_token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: jwtToken }),
      });
      const responseData = await response.json();
      if (responseData.detail !== 'License expired') {
        const getCoursesCount = await axios.get(`${process.env.REACT_APP_ENDPOINT}/instructors/{instructor_id}/account/?email=${responseData.email}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${responseData.access_token}`
          }
        });
        const { firstName, lastName, email, instructor_id, organization_id, emailActivated, accountActive, admin_id, single_count, journey_count, questions_count, student_count, profilePicture } = getCoursesCount.data;
        const LearnerTab = admin_id ? 'hide' : 'show';
        const Onboarding = accountActive ? 2 : 0;
        Cookies.set("instructor_id", instructor_id, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        localStorage.setItem("profilePicture", profilePicture);
        Cookies.set("admin_id", admin_id, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        localStorage.setItem("name", firstName);
        localStorage.setItem("lastname", lastName);
        localStorage.setItem("email", email);
        localStorage.setItem("gamizign_returning_instructor", "true");
        localStorage.setItem("gamizign_last_login_email", email);
        localStorage.removeItem("gamizign_license_expired");
        Cookies.set("organization", organization_id, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        localStorage.setItem("user_type", responseData.user_type);
        Cookies.set("token", `Bearer ${responseData.access_token}`, {
          expires: 30,
          secure: true,
          sameSite: "Lax",
          domain: currentDomain
        });

        localStorage.setItem("LearnersList", LearnerTab);
        localStorage.setItem("accountActive", single_count + journey_count);
        Cookies.set("plan", responseData.license.license_type, {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        localStorage.setItem("coursesLength", single_count + journey_count);
        localStorage.setItem("singleCourses", single_count);
        localStorage.setItem("journeyCourses", journey_count);
        localStorage.setItem("qestionListsLength", questions_count);
        localStorage.setItem("studentsLength", student_count);
        localStorage.setItem("emailActive", emailActivated ? emailActivated : "");
        Cookies.set("activatedTrial", responseData.license.activatedTrial ? responseData.license.activatedTrial : "", {
          expires: 30, secure: true,
          sameSite: "Lax", domain: currentDomain
        });
        const urlPath = localStorage.getItem('urlPath');
        if (urlPath) {
          localStorage.removeItem('urlPath');
          window.location.href = urlPath;
        } else if ((single_count + journey_count) > 0) {
          window.location.href = `/Dashboard`;
          sessionStorage.setItem("tab", responseData.license.license_type > 2 ? 11 : 4);
        } else {
          window.location.href = `/Dashboard/CreateCourse`;
          sessionStorage.setItem("tab", 11);
        }
      } else {
        localStorage.setItem("gamizign_license_expired", "true");
        setCohort("returning_expired");
        if (responseData?.admin_id) {
          setErrorMessage(t('Signin.LicenseExpiredAdmin'));
          setPymentError(true);
        } else {
          setErrorMessage(t('Signin.LicenseExpired1'));
          setPymentError(true);
        }
      }

    } catch (error) {
      console.log('=> Error whlie login by google', error);
      if (error?.response?.status === 402) {
        const detail = error.response.data.detail;
        Cookies.set("token", `Bearer ${detail.access_token}`, {
          expires: 30,
          secure: true,
          sameSite: "Lax",
          domain: currentDomain // <-- Note: Still recommend removing this for stability (see below)
        });

        localStorage.setItem('updatesPlan', detail.license_type);
        localStorage.setItem('updatesBill_type', detail.bill_type);
        setdetalsData(detail);
        localStorage.setItem("gamizign_license_expired", "true");
        setCohort("returning_expired");
        if (detail.new_user) {
          setErrorMessage(t('Signin.LicenseExpired'));
          setPymentError(true);
          setTimeout(() => {
            navigate('/payment', {
              state: {
                license_type: detail.license_type,
                bill_type: detail.bill_type,
                organization_id: detail.organization_id
              }
            });
          }, 2000);
          // navigate('/payment', { state: { license_type: detail.license_type, bill_type: detail.bill_type, organization_id: detail.organization_id } });
        } else {
          setErrorMessage(t('Signin.LicenseExpired1'));
          setPymentError(true);
        }
        errorMgs = t('Signin.LicenseExpired');
      } else { errorMgs = 'noAccount' }
    } finally {
      setState((prevState) => ({ ...prevState, error: errorMgs, isLoading: false }));
      handleLoginResult(false);
    }
  };
  const [pymentError, setPymentError] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState('');
  // Resend verification email
  const [ActiveEmail, setActiveEmail] = useState({});
  const [Progrees, setProgrees] = useState(false);
  const resendVarification = async () => {
    setProgrees(true);
    const currentTime = new Date().getTime();
    const lastRequestTime = sessionStorage.getItem('lastRequestTime');
    if (lastRequestTime && currentTime - lastRequestTime < 3600000) {
      setErrorMessage('You requested activation email in the last hour, check you Mail spam folder or try after one hour.');
      setProgrees(false);
      return;
    }
    try {
      const response = await axios.post(`${process.env.REACT_APP_ENDPOINT}/send-activation-email`, ActiveEmail);
      if (response.status === 200) {
        setErrorMessage('Email has been resent');
        sessionStorage.setItem('lastRequestTime', currentTime);

      }
    } catch (error) {
      setErrorMessage('An error occured while resending email try again later.');
      setProgrees(false);

    } finally {
      setProgrees(false);
    }

  };
  const closeDialog = () => {
    setPymentError(false);
    handleLoginResult(false);
  }
  useEffect(() => {
    const currentLogo = logoRef.current; // Store the current value of the ref
    if (currentLogo) {
      // Listen for the end of the logo animation
      const handleAnimationEnd = () => {
        // Show login fields after logo animation completes
        setShowLoginFields(true);
      };

      // Add event listener to the logo animation
      currentLogo.addEventListener('animationend', handleAnimationEnd);

      // Cleanup function to remove event listener from the stored currentLogo element
      return () => {
        currentLogo.removeEventListener('animationend', handleAnimationEnd);
      };
    }
  }, [i18n]);
  const [errorGettingAuth, setErrorGettingAuth] = useState('');
  const [goldCourse, setGoldCourse] = useState(true);
  const handleTryGold = async () => {
    setErrorGettingAuth('');
    try {
      setState((prevState) => ({ ...prevState, isLoading: true }));
      const GetToken = await axios.post(`${process.env.REACT_APP_ENDPOINT}/token`,
        {
          "username": "1",
          "password": "123"
        }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        },
      });
      const token = GetToken.data.access_token;
      Cookies.set("token", `Bearer ${token}`, {
        expires: 30,
        secure: true,
        sameSite: "Lax",
        domain: currentDomain // <-- Note: Still recommend removing this for stability (see below)
      });
      // navigate('/gamizigngold');
      window.location.href = '/gamizigngold';
    } catch (error) {
      console.error('error getting token', error);
      setErrorGettingAuth('Someting wend wrong try again.')
    } finally { setState((prevState) => ({ ...prevState, isLoading: false })); }
  }

  return (
    // <Paper>
    <div style={{ backgroundImage: `url(${mode === 'light' ? GMZbgLight : GMZbgDark})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
      <MetaTags title={t("Signin.WelcomeGamizign")} description='Welcome to Gamizign page--' />
      <div className={`z-10 absolute top-0 ${i18n.language === 'en' ? 'right-1 sm:right-3' : 'left-1 sm:left-3'} p-2 flex items-center gap-2`}>
        <ThemeToggle mode={mode} setMode={setMode} />
        {/* Language Selector */}
        <LanguageSwitcher />
      </div>
      <Dialog open={pymentError} onClose={closeDialog} disabled={Progrees}>
        <DialogContent>
          {Progrees && (
            <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-75 z-50">
              <CircularProgress className="text-blue-800" />
            </div>
          )}
          <Alert severity={ErrorMessage === t('Signin.ReactiveSuccess') ? 'success' : "error"}>{ErrorMessage}</Alert>
        </DialogContent>
        {ErrorMessage === t('Signin.LicenseExpired1') ?
          <div className='flex justify-center'>
            <Button onClick={repay} color="primary">
              {/* <Link to={`/upgradeplan?email=${ActiveEmail.email}`}> */}
              <p>{t('Signin.Upgrade')}</p>
              {/* </Link> */}
            </Button>
            <Button onClick={closeDialog} color="primary">
              <p>{t('Signin.Okay')}</p>
            </Button>
          </div> : <div className='flex justify-center'>
            {ErrorMessage === t('Signin.AccountDeactivatedMsg') &&
              <Button onClick={ReActivateAccount}>
                {t('Signin.ReActive')}
              </Button>}
            <Button onClick={closeDialog} color="primary">
              <p>{ErrorMessage === t('Signin.AccountDeactivatedMsg') ? t('Signin.Cancel') : t('Signin.Okay')}</p>
            </Button>
          </div>}
      </Dialog>
      <div className="min-h-screen w-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" style={{ direction: i18n.language === 'ar' ? 'rtl' : 'ltr' }}>

        <div className="max-w-5xl w-full flex flex-col md:flex-row items-center gap-8 lg:gap-16 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md rounded-[32px] p-6 sm:p-10 border border-white/30 dark:border-slate-800/30 shadow-[0_32px_64px_-16px_rgba(0,0,0,0.15)]">

          {/* Left/Right Side (Motivational Side Panel) */}
          <div className="flex-1 text-slate-800 dark:text-slate-100 flex flex-col gap-6 max-w-lg">

            {/* Cohort 1: First Timer (Interactive Simulator & Value Copy) */}
            {cohort === "first_timer" && (
              <>
                <div className="flex flex-col gap-3">
                  <span className="bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-[11px] font-black uppercase tracking-widest px-3 py-1 rounded-full w-fit animate-pulse">
                    {i18n.language === 'ar' ? '🚀 انضم إلى قادة التعليم التفاعلي' : '🚀 JOIN 5,000+ CREATIVE EDUCATORS'}
                  </span>

                  <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-800 dark:text-slate-100 leading-tight">
                    {i18n.language === 'ar' ? (
                      <>
                        حوّل موادك الدراسية إلى <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-blue-600">ألعاب تعليمية شيقة!</span>
                      </>
                    ) : (
                      <>
                        Gamify Your Educational <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-blue-600">Materials in 1-Click</span>
                      </>
                    )}
                  </h2>

                  <p className="text-sm sm:text-base text-slate-500 dark:text-slate-400 font-medium leading-relaxed">
                    {i18n.language === 'ar' ? (
                      "انضم إلى آلاف المعلمين المبدعين الذين يقومون بتبسيط المحتوى وتحويل ملفات PDF و PPTX والأسئلة التقليدية إلى مسارات ومغامرات تفاعلية تثير حماس الطلاب وتزيد من تفاعلهم لحظياً."
                    ) : (
                      "Upload your standard PDFs, slides, or prompts and watch the AI extract staging, custom questions, and engaging mechanics instantly. Turn learning into an adventure your students won't want to leave."
                    )}
                  </p>
                </div>

                {/* Interactive Auto-Gamify Simulator */}
                {/* <div className="flex flex-col gap-4 bg-white/70 dark:bg-slate-950/70 border border-slate-100 dark:border-slate-800 p-5 rounded-2xl shadow-sm">
                  <h4 className="text-sm font-black text-slate-800 dark:text-slate-200 flex items-center gap-1.5">
                    <span>✨</span> {i18n.language === 'ar' ? 'جرب تلعيب موادك الآن (معاينة سريعة):' : 'Try Gamifying Your Material (Quick Preview):'}
                  </h4>

                  {simulatedStep === 'idle' && (
                    <div className="flex flex-col gap-3">
                      <p className="text-xs text-slate-500 dark:text-slate-400 font-medium">
                        {i18n.language === 'ar' ? 'اختر نوع مستندك الدراسي لترى كيف سيحوله الذكاء الاصطناعي إلى لعبة:' : 'Select your course material type to see how our AI turns it into an immersive game stage:'}
                      </p>
                      <div className="grid grid-cols-3 gap-2">
                        <button
                          type="button"
                          onClick={() => startSimulation('pdf')}
                          className="py-2 px-1 text-[11px] font-bold bg-cyan-50 hover:bg-cyan-100 border border-cyan-100 rounded-xl transition-all duration-300 text-cyan-700 flex flex-col items-center gap-1"
                        >
                          <span>📄</span> PDF Lecture
                        </button>
                        <button
                          type="button"
                          onClick={() => startSimulation('pptx')}
                          className="py-2 px-1 text-[11px] font-bold bg-amber-50 hover:bg-amber-100 border border-amber-100 rounded-xl transition-all duration-300 text-amber-700 flex flex-col items-center gap-1"
                        >
                          <span>📊</span> PPTX Slides
                        </button>
                        <button
                          type="button"
                          onClick={() => startSimulation('ai')}
                          className="py-2 px-1 text-[11px] font-bold bg-purple-50 hover:bg-purple-100 border border-purple-100 rounded-xl transition-all duration-300 text-purple-700 flex flex-col items-center gap-1"
                        >
                          <span>⚡</span> AI Prompt
                        </button>
                      </div>
                    </div>
                  )}

                  {simulatedStep === 'processing' && (
                    <div className="flex flex-col items-center py-4 gap-3 text-center">
                      <CircularProgress size={30} className="text-[#4183d9]" />
                      <div className="flex flex-col gap-1">
                        <p className="text-xs font-black text-slate-800 dark:text-slate-200 animate-pulse">
                          {simulatedText}
                        </p>
                        <p className="text-[10px] text-slate-400 dark:text-slate-500 font-bold uppercase tracking-wider">
                          {i18n.language === 'ar' ? 'جاري بناء هيكل اللعبة...' : 'AI Staging Engine Active'}
                        </p>
                      </div>
                    </div>
                  )}

                  {simulatedStep === 'done' && (
                    <div className="flex flex-col gap-3 animate-fade-in">
                      <div className="p-3 bg-gradient-to-r from-emerald-50 to-teal-50/50 border border-emerald-100 rounded-xl flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <span className="text-2xl">🏆</span>
                          <div>
                            <h5 className="text-xs font-black text-slate-800 dark:text-slate-200">
                              {simulatedMaterial === 'pdf' ? (i18n.language === 'ar' ? 'ملف PDF: مستويات اللعبة جاهزة' : 'PDF Lecture: Staging Ready') : simulatedMaterial === 'pptx' ? (i18n.language === 'ar' ? 'عرض التقديمي: مستويات اللعبة جاهزة' : 'PPTX Slides: Staging Ready') : (i18n.language === 'ar' ? 'موضوع الذكاء الاصطناعي: جاهز' : 'AI Topic Staging Ready')}
                            </h5>
                            <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wide mt-0.5">
                              {simulatedMaterial === 'pdf' ? (i18n.language === 'ar' ? '🎯 النمط: رحلة الفضاء' : '🎯 Style: Space Quest Stage') : simulatedMaterial === 'pptx' ? (i18n.language === 'ar' ? '🎯 النمط: جزيرة الكنز' : '🎯 Style: Treasure Quest') : (i18n.language === 'ar' ? '🎯 النمط: مسابقة الأسئلة التفاعلية' : '🎯 Style: Trivia Quiz Show')}
                            </p>
                          </div>
                        </div>
                        <span className="bg-emerald-100 text-emerald-800 text-[10px] font-black px-2 py-0.5 rounded-full">
                          100% OK
                        </span>
                      </div>

                      <div className="flex gap-2">
                        <button
                          type="button"
                          onClick={() => setSimulatedStep('idle')}
                          className="flex-1 py-2 text-xs font-bold text-slate-500 hover:text-slate-700 bg-slate-100 rounded-xl hover:bg-slate-200 transition-all duration-300"
                        >
                          {i18n.language === 'ar' ? 'إعادة التجربة' : 'Try Another'}
                        </button>
                        <button
                          type="button"
                          onClick={() => navigate('/signup')}
                          className="flex-[2] py-2 text-xs font-black text-white bg-gradient-to-r from-cyan-500 to-blue-500 rounded-xl hover:opacity-90 shadow-md hover:scale-[1.02] transition-all duration-300"
                        >
                          {i18n.language === 'ar' ? 'سجل تفعيل هذه اللعبة مجاناً 🚀' : 'Register & Claim This Game 🚀'}
                        </button>
                      </div>
                    </div>
                  )}

                </div> */}
              </>
            )}

            {/* Cohort 2: Returning Active (Warm Welcome back & quick start actions) */}
            {cohort === "returning_active" && (
              <>
                <div className="flex flex-col gap-3">
                  <span className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-[11px] font-black uppercase tracking-widest px-3 py-1 rounded-full w-fit">
                    {i18n.language === 'ar' ? '⚡ مرحباً بعودتك، أيها المبدع' : '⚡ WELCOME BACK, EDUCATOR'}
                  </span>

                  <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-800 dark:text-slate-100 leading-tight">
                    {i18n.language === 'ar' ? (
                      <>
                        دعنا نطلق لعبة <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-teal-600">تفاعلية جديدة!</span>
                      </>
                    ) : (
                      <>
                        Ready to Launch <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-teal-600">Another Game?</span>
                      </>
                    )}
                  </h2>

                  <p className="text-sm sm:text-base text-slate-500 dark:text-slate-400 font-medium leading-relaxed">
                    {i18n.language === 'ar' ? (
                      "فصلك الدراسي جاهز لاستقبال مرحلة جديدة من الحماس. قم بالدخول فوراً لمتابعة تقدم طلابك وتعديل مساقاتك وإطلاق ألعاب تفاعلية مباشرة."
                    ) : (
                      "Your classes are loaded and waiting. Log in directly to view student response rates, build custom slides, or launch live active sessions in seconds."
                    )}
                  </p>
                </div>

                {/* Returning User Value Points */}
                <div className="flex flex-col gap-4 bg-white/60 dark:bg-slate-950/60 border border-slate-100 dark:border-slate-800 p-5 rounded-2xl">

                  <div className="flex items-start gap-3">
                    <div className="flex items-center justify-center bg-emerald-100/60 p-2 rounded-xl text-emerald-600 shrink-0">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-sm font-bold text-slate-800 dark:text-slate-200">
                        {i18n.language === 'ar' ? "إنشاء سريع في دقيقتين" : "Quick Game Drafting"}
                      </h4>
                      <p className="text-xs text-slate-400 font-medium mt-0.5">
                        {i18n.language === 'ar' ? "قوالبك السابقة ومسوداتك جاهزة للمضاعفة الفورية." : "Your previously saved presets and formats are ready to replicate."}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="flex items-center justify-center bg-blue-100/60 p-2 rounded-xl text-blue-600 shrink-0">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 002 2h2a2 2 0 002-2z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-sm font-bold text-slate-800">
                        {i18n.language === 'ar' ? "متابعة تقدم الطلاب" : "Live Response Tracking"}
                      </h4>
                      <p className="text-xs text-slate-400 font-medium mt-0.5">
                        {i18n.language === 'ar' ? "شاهد فوراً نتائج التقييم التفاعلي وأسماء المتصدرين." : "Monitor responses and leaderboard performance in real time."}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Cohort 3: Returning Expired / Lapsed (Preservation emphasis) */}
            {cohort === "returning_expired" && (
              <>
                <div className="flex flex-col gap-3">
                  <span className="bg-gradient-to-r from-amber-500 to-orange-500 text-white text-[11px] font-black uppercase tracking-widest px-3 py-1 rounded-full w-fit">
                    {i18n.language === 'ar' ? '🔓 لقد افتقدناك كثيراً' : '🔓 WE MISSED YOU!'}
                  </span>

                  <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-800 dark:text-slate-100 leading-tight">
                    {i18n.language === 'ar' ? (
                      <>
                        دعنا نطلق العنان <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-orange-600">لفصلك مجدداً!</span>
                      </>
                    ) : (
                      <>
                        Reactivate Your <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-orange-600">Classroom Today!</span>
                      </>
                    )}
                  </h2>

                  <p className="text-sm sm:text-base text-slate-500 dark:text-slate-400 font-medium leading-relaxed">
                    {i18n.language === 'ar' ? (
                      "ألعابك ومسوداتك السابقة ومحاولات طلابك محفوظة بأمان تام في انتظارك. نشّط حسابك فوراً لمواصلة التدريس التفاعلي واستخدام أدوات AI المتقدمة."
                    ) : (
                      "All of your previously designed game slides and student record histories are fully preserved. Reactivate today to continue providing gamified courses."
                    )}
                  </p>
                </div>

                {/* Expired User Value Points */}
                <div className="flex flex-col gap-4 bg-white/60 dark:bg-slate-950/60 border border-slate-100 dark:border-slate-800 p-5 rounded-2xl">

                  <div className="flex items-start gap-3">
                    <div className="flex items-center justify-center bg-amber-100/60 p-2 rounded-xl text-amber-600 shrink-0">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-sm font-bold text-slate-800 dark:text-slate-200">
                        {i18n.language === 'ar' ? "حفظ آمن للمسودات" : "Draft Preservation guaranteed"}
                      </h4>
                      <p className="text-xs text-slate-400 font-medium mt-0.5">
                        {i18n.language === 'ar' ? "لم نفقد أي بيانات، كل محتواك في انتظار تفعيلك." : "Zero content loss. Your full creation suite remains exactly as you left it."}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="flex items-center justify-center bg-cyan-100/60 p-2 rounded-xl text-cyan-600 shrink-0">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-sm font-bold text-slate-800">
                        {i18n.language === 'ar' ? "ميزات الذكاء الاصطناعي المحدثة" : "Upgraded AI Features"}
                      </h4>
                      <p className="text-xs text-slate-400 font-medium mt-0.5">
                        {i18n.language === 'ar' ? "توليد فوري ومحسّن للأسئلة والأدوات التعليمية بذكاء خارق." : "Experience faster document-to-stage AI synthesis in our latest release."}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Dynamic stats row */}
            <div className="grid grid-cols-3 gap-4 text-center mt-2 border-t border-slate-200/50 dark:border-slate-800/50 pt-5">
              <div>
                <span className="text-2xl font-black text-slate-800 dark:text-slate-100">50K+</span>
                <p className="text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide mt-0.5">
                  {i18n.language === 'ar' ? "لاعب نشط" : "Active Players"}
                </p>
              </div>
              <div>
                <span className="text-2xl font-black text-slate-800 dark:text-slate-100">10K+</span>
                <p className="text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide mt-0.5">
                  {i18n.language === 'ar' ? "لعبة مخصصة" : "Games Built"}
                </p>
              </div>
              <div>
                <span className="text-2xl font-black text-slate-800 dark:text-slate-100">98%</span>
                <p className="text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wide mt-0.5">
                  {i18n.language === 'ar' ? "رضا المعلمين" : "Teacher Love"}
                </p>
              </div>
            </div>
          </div>

          {/* Split Divider line on large screens */}
          <div className="hidden md:block w-[1px] self-stretch bg-gradient-to-b from-transparent via-slate-200 to-transparent"></div>

          {/* Right Side (Actual Credentials Form) */}
          <div className="flex-none SignIn text-center justify-center px-0 py-0 w-full md:w-[360px]">
            <div className="flex justify-center mb-2">
              <img className={`${!animationStop && 'logo'}`} ref={logoRef} src={GamizignLogo} width={180} alt="LogoImage" />
            </div>

            <div className={`${!animationStop && 'login-fields-container'} ${!animationStop && showLoginFields ? 'login-fields' : ''}`}>
              <div className="drop-shadow-xl rounded-[24px] bg-transparent relative">
                {state.isLoading && (
                  <div className="absolute inset-0 py-40 flex justify-center items-center bg-transparent bg-opacity-75 z-50 rounded-3xl">
                    <CircularProgress className="text-blue-800" />
                  </div>
                )}
                <form className="container p-3 px-5" action="post" onSubmit={handleSubmit}>
                  {/* Segmented Sliding Tab Control */}
                  <div className="flex bg-[#EBF1FA] dark:bg-slate-950 p-1 rounded-full mb-6 max-w-sm mx-auto shadow-inner relative border border-slate-200/50 dark:border-slate-800/60">
                    {/* Sliding highlight indicator pill */}
                    <div
                      className="absolute top-1 bottom-1 w-[calc(50%-4px)] bg-white dark:bg-slate-800 border border-transparent dark:border-slate-700/80 rounded-full shadow-[0_2px_8px_rgba(0,0,0,0.06)] dark:shadow-[0_2px_8px_rgba(0,0,0,0.4)] transition-all duration-300 ease-out"
                      style={{
                        left: i18n.language === 'ar' ? '50%' : '4px',
                      }}
                    ></div>

                    {/* Tab 1: SIGN IN (Active) */}
                    <button
                      type="button"
                      className="tab-btn flex-1 py-2 text-sm font-black text-center z-10 transition-colors duration-300 relative focus:outline-none text-blue-900 dark:text-cyan-400"
                    >
                      {t('Signin.signin')}
                    </button>

                    {/* Tab 2: SIGN UP (Redirects) */}
                    <button
                      type="button"
                      onClick={() => navigate('/signup')}
                      className="tab-btn flex-1 py-2 text-sm font-bold text-center z-10 transition-colors duration-300 relative focus:outline-none text-slate-500 dark:text-slate-400 hover:text-blue-900 dark:hover:text-slate-200"
                    >
                      {i18n.language === 'ar' ? 'إنشاء حساب جديد' : 'Create Account'}
                    </button>
                  </div>

                  <TextField
                    margin="dense"
                    label={t("Signin.Email")}
                    name="email"
                    type="email"
                    required
                    defaultValue={localStorage.getItem("gamizign_last_login_email") || ""}
                    placeholder="mohd@example.com"
                    fullWidth
                    sx={{
                      marginTop: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        '& fieldset': {
                          border: mode === 'light' ? 'none' : '',
                          borderRadius: '10px',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #4183d9',
                          borderRadius: '10px',
                        },
                      },
                      '& input': {
                        textAlign: i18n.language === 'ar' ? 'right' : 'left',
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon style={{ color: mode === 'light' ? '#4183d9' : '' }} />
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: "10px",
                        color: mode === 'light' ? '#4183d9' : '', background: mode === 'light' ? 'white' : '',
                        fontSize: '20px',
                      }
                    }}
                  />
                  <TextField
                    margin="dense"
                    label={t("Signin.Password")}
                    name="password"
                    type={state.showPassword ? 'text' : 'password'}
                    required
                    placeholder={t("Signin.PasswordPlaceholder")}
                    fullWidth
                    className=""
                    sx={{
                      marginTop: '20px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        '& fieldset': {
                          border: mode === 'light' ? 'none' : '',
                          borderRadius: '10px',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #4183d9',
                          borderRadius: '10px',
                        },
                      },
                      '& input': {
                        textAlign: i18n.language === 'ar' ? 'right' : 'left',
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <span onClick={togglePasswordVisibility} className="cursor-pointer">{state.showPassword ? <VisibilityIcon style={{ color: mode === 'light' ? '#4183d9' : '' }} size={24} /> : <VisibilityOffIcon style={{ color: mode === 'light' ? '#4183d9' : '' }} size={24} />}</span>
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: "12px",
                        fontSize: '20px',
                        color: mode === 'light' ? '#4183d9' : '', background: mode === 'light' ? 'white' : '',
                      }
                    }}
                  />
                  {state.error && <p style={{ color: 'red' }}>{state.error === 'noAccount' ? <p>{t('Signin.NoAccount')} <span className="text-[#4183d9] font-bold cursor-pointer" onClick={() => { navigate('/signup') }}>{t('Signin.SignUp')}</span></p> : state.error}</p>}
                  <button className="py-1 flex justify-start font-bold ms-2 1mt-2" style={{ color: '#4183d9' }} type="button"><Link to='/reset-password'>{t("Signin.ForgotPassword")}</Link></button>
                  <div className="flex justify-center items-center gap-1 py-1 mb-5"><img src={HeartIcon} alt="HeartIcon" /><p>{t("Signin.Kindly")}</p></div>

                  {/* Primary Sign In Button */}
                  <button className="relative overflow-hidden group transition-all duration-500 btn GameOn dark:!bg-cyan-600 hover:scale-105 text-2xl py-2.5 w-full rounded-xl shadow-md hover:shadow-lg text-slate-800 dark:text-white" type="submit" disabled={state.isLoading}>
                    <span className={`absolute inset-0 bg-[#F6C1C1] dark:bg-cyan-700 ${i18n.language === 'ar' ? 'translate-x-full' : '-translate-x-full'}  group-hover:translate-x-0 transition-transform duration-500`}></span>
                    <label className="relative cursor-pointer"><b>{t('Signin.signin')}</b></label>
                  </button>

                  {/* Google Login Separator */}
                  <div className="flex items-center gap-3 my-5">
                    <span className="h-[1px] bg-slate-200/60 flex-1"></span>
                    <span className="text-xs font-semibold text-slate-400 uppercase tracking-widest">
                      {i18n.language === 'ar' ? 'أو عبر' : 'OR WITH'}
                    </span>
                    <span className="h-[1px] bg-slate-200/60 flex-1"></span>
                  </div>

                  {/* Google Login Component */}
                  <div className="flex justify-center w-full mb-6">
                    <GoogleOAuthProvider clientId="1071328084227-056krbch512vrpup6fgevl6j8i55g7ic.apps.googleusercontent.com">
                      <GoogleLogin
                        onSuccess={handleGoogleLogin}
                        shape="circle"
                        type="standard"
                        logo_alignment="left"
                        text="signin_with"
                        theme="filled_blue"
                        size="large"
                        locale={i18n.language === "ar" ? "ar" : "en"}
                        useOneTap
                        disabled={state.isLoading}
                      />
                    </GoogleOAuthProvider>
                  </div>

                  {/* Clean, high-converting footer invitation */}
                  <div className="pt-4 border-t border-slate-100/80 text-center">
                    <p className="text-sm font-medium text-slate-500">
                      {i18n.language === 'ar' ? 'ليس لديك حساب؟ ' : "Don't have an account? "}
                      <span
                        onClick={() => navigate('/signup')}
                        className="text-[#4183d9] font-black cursor-pointer hover:underline ms-1 transition-all duration-300"
                      >
                        {i18n.language === 'ar' ? 'سجل الآن مجاناً 🚀' : 'Sign Up Free 🚀'}
                      </span>
                    </p>
                  </div>
                </form>
              </div>
              <p className="mt-4"><Link className="" target="_blank" to="https://gamizign.com/privacy-policy/">{t("Signin.PrivacyPolicyTerms")}</Link></p>
              <p className="mt-4"><Link className="" target="_blank" to="https://gamizign.com/refund-policy/">{t("Signin.RefundCancellation")}</Link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </Paper>
  );

};
export default SignIn;
